<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <BaseCard
                        :loading-allowed="false"
                        :v-card-text-class="'pa-0'"
                        icon="mdi-filter-variant"
                        title="Sale Invoice Filter"
                    >
                        <v-form @submit.prevent="submit">
                            <v-row dense class="pa-2">
                                <v-col cols="12" lg="3" md="2" sm="6">
                                            <v-date-input
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                bg-color="grey-lighten-4"
                                                clearable
                                                hide-details
                                                density="compact"
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar-month"
                                                variant="outlined"
                                            />
                                </v-col>
                                <v-col cols="12" lg="3" md="2" sm="6">
                                            <v-date-input
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                bg-color="grey-lighten-4"
                                                clearable
                                                density="compact"
                                                hide-details
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar-month"
                                                variant="outlined"
                                            />
                                </v-col>
                            </v-row>
                            <v-divider />
                            <v-card-actions class="justify-end">
                                <v-btn
                                    ref="searchButton"
                                    class="bg-brand"
                                    prepend-icon="mdi-magnify"
                                    type="submit"
                                >
                                    Search
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </BaseCard>
                </v-col>
        <v-col cols="12">
                    <BaseCard
                        :loading-allowed="false"
                        :v-card-text-class="'pa-0'"
                        icon="mdi-clipboard-text-outline"
                        title="Sale Invoice List"
                    >
                        <v-row align="center" class="py-2 px-1">
                            <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            bg-color="grey-lighten-4"
                                            clearable
                                            density="compact"
                                            hide-details
                                            label="Search"
                                            single-line
                                            variant="outlined"
                                        />
                            </v-col>
                            <v-col cols="12" md="4">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group density="compact" divided size="small" variant="outlined">
                                                <v-btn
                                                    color="success"
                                                    prepend-icon="mdi-download"
                                                    variant="flat"
                                                    @click="exportToCSV"
                                                >
                                                    CSV
                                                </v-btn>
                                                <v-btn
                                                    color="primary"
                                                    prepend-icon="mdi-download"
                                                    variant="flat"
                                                    @click="exportToExcel"
                                                >
                                                    EXCEL
                                                </v-btn>
                                                <v-btn
                                                    color="red"
                                                    prepend-icon="mdi-download"
                                                    variant="flat"
                                                    @click="exportToPDF"
                                                >
                                                    PDF
                                                </v-btn>
                                            </v-btn-group>
                                        </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="text-right pr-2"></div>
                            </v-col>
                        </v-row>
                                <v-data-table
                                  :headers="headers"
                                  :items="getSchema"
                                  :loading="loading"
                                  v-model:items-per-page="itemsPerPage"
                                  :search="search"
                                  :hover="true"
                                  density="compact"
                                >
                                    <template v-slot:loader>
                                        <v-progress-linear
                                            :color="loading"
                                            height="3"
                                            indeterminate
                                        />
                                    </template>
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.code="{ item }">
                                      <div class="text-left px-1">{{ item?.code }}</div>
                                    </template>

                                    <template v-slot:item.sale_invoice_delivery.invoice_master.code="{ item }">
                                      <div class="text-left px-1">{{ item?.sale_invoice_delivery?.invoice_master?.code }}</div>
                                    </template>

                                    <template v-slot:item.ref_no="{ item }">
                                      <div class="text-left px-1">{{ item?.ref_no }}</div>
                                    </template>

                                    <template v-slot:item.po_no="{ item }">
                                      <div class="text-left px-1">{{ item?.po_no }}</div>
                                    </template>

                                    <template v-slot:item.customer="{ item }">
                                      <div class="text-left px-1">
                                        {{ item?.customer?.company_name ? item.customer.company_name : item?.customer?.company_owner_name ? item.customer.company_owner_name : '' }}
                                      </div>
                                    </template>

                                    <template v-slot:item.work_order="{ item }">
                                      <div class="text-left px-1">{{ item?.work_order?.code }}</div>
                                    </template>

                                    <template v-slot:item.sale_invoice_date="{ item }">
                                      <div class="text-left px-1">{{ item?.sale_invoice_date }}</div>
                                    </template>

                                    <template v-slot:item.sale_invoice_delivery.invoice_master.sale_order_date="{ item }">
                                      <div class="text-left px-1">{{ item?.sale_invoice_delivery?.invoice_master?.sale_order_date }}</div>
                                    </template>

                                    <template v-slot:item.shipping_date="{ item }">
                                      <div class="text-left px-1">{{ item?.shipping_date }}</div>
                                    </template>

                                    <template v-slot:item.sale_invoice_delivery.invoice_master.employee.name="{ item }">
                                      <div class="text-left px-1">{{ item?.sale_invoice_delivery?.invoice_master?.employee?.name }}</div>
                                    </template>

                                    <template v-slot:item.sub_total="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.sub_total) }}</div>
                                    </template>

                                    <template v-slot:item.discount_amount="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.discount_amount) }}</div>
                                    </template>

                                    <template v-slot:item.vat_amount="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.vat_amount) }}</div>
                                    </template>

                                    <template v-slot:item.tax_amount="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.tax_amount) }}</div>
                                    </template>

                                    <template v-slot:item.total="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.total) }}</div>
                                    </template>

                                    <template v-slot:item.total_paid="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.total_paid) }}</div>
                                    </template>

                                    <template v-slot:item.tax_adjustment="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.tax_adjustment) }}</div>
                                    </template>

                                    <template v-slot:item.due_amount="{ item }">
                                      <div class="text-end px-1">{{ $numberFormat(item?.due_amount) }}</div>
                                    </template>

                                    <template v-slot:item.next_payment_date="{ item }">
                                      <div class="text-left px-1">{{ item?.next_payment_date }}</div>
                                    </template>

                                    <template v-slot:item.approved_ind="{ item }">
                                        <v-chip
                                        v-if="item.approved_ind == 1"
                                        color="success"
                                        size="small"
                                        class="text-capitalize"
                                        >Yes</v-chip
                                        >
                                        <v-chip
                                        v-else
                                        color="red"
                                        size="small"
                                        class="text-capitalize"
                                        >No</v-chip
                                        >
                                    </template>

                                    <template v-slot:item.approval_status_display="{ item }">
                                      <v-chip
                                        v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                        color="yellow-darken-3"
                                        size="small"
                                      >
                                        Wating for {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>

                                      <v-chip
                                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                        color="green"
                                        size="small"
                                      >
                                        Approved By {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>
                                      <v-chip
                                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                        color="red"
                                        size="small"
                                      >
                                        Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        color="green"
                                        size="small"
                                      >
                                        {{ item.approval_status }}
                                      </v-chip>
                                    </template>
                                    
                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                        :color="statusMap[item.status]?.color || 'grey'"
                                        size="small"
                                        class="text-capitalize"
                                        >
                                        {{ statusMap[item.status]?.label || "Unknown" }}
                                        </v-chip>
                                    </template>

                                     <template v-slot:item.payment_status="{ item }">
                                        <v-chip
                                          v-if="item.due_amount == item.total"
                                          color="yellow"
                                          size="small"
                                          class="text-capitalize"
                                        >
                                        Not Paid
                                        </v-chip>


                                        <v-chip
                                          v-if="item.due_amount < item.total && item.due_amount > 0"
                                          color="primary"
                                          size="small"
                                          class="text-capitalize"
                                        >
                                          Partial Paid
                                        </v-chip>
                                        <v-chip
                                          v-if="item.due_amount <= 0"
                                          color="green"
                                          size="small"
                                          class="text-capitalize"
                                          >
                                          Paid
                                        </v-chip>
                                    </template>


                                    <template v-slot:item.actions="{ item }">
                                        <v-icon
                                              small
                                              @click="viewInvoice(item)"
                                              v-if="$updateAccess($route.fullPath) && item.status == '1'"
                                              class="me-2 edit-button"
                                              title="View Invoice"
                                              color="blue"
                                          >
                                            mdi-file-document-outline
                                        </v-icon>
                                        
                                        <v-icon
                                          class="me-2 edit-button"
                                          color="primary"
                                          @click="editItem(item)"
                                          v-if="$updateAccess($route.fullPath) && item.lock == '0' && canEdit(item)"
                                        >
                                          mdi mdi-pencil-outline
                                        </v-icon>

                                        <v-icon
                                          class="me-2 edit-button"
                                          color="primary"
                                          @click="poPayment(item)"
                                          v-if="$updateAccess($route.fullPath) && item.lock == '0' && item.due_amount <= item.total && item.due_amount > 0 && item.status == '1' && item.approval_status != 'Pending'"
                                          title="PO Payment"
                                        >
                                          mdi-currency-usd
                                        </v-icon>

                                        <v-icon
                                          class="me-2 edit-button"
                                          color="primary"
                                          @click="openBalanceSummary(item)"
                                          v-if="Number(item.paid) === 0 && item.customer_map_id && $updateAccess('/sales/customer-balance-summary')"
                                          title="Customer Balance Summary"
                                        >
                                          mdi-invoice-edit-outline
                                        </v-icon>

                                        <v-icon
                                          class="me-2 edit-button"
                                          color="warning"
                                          @click="openTaxAdjustment(item)"
                                          v-if="$updateAccess($route.fullPath) && item.due_amount > 0 && item.approval_status != 'Pending'"
                                          title="Tax Adjustment"
                                        >
                                          mdi-cash-fast
                                        </v-icon>
                                    </template>
                                </v-data-table>
                    </BaseCard>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
    <poPaymentSetup
      v-model:dialog="dialog"
      :data="data"
      @update:dialog="dialog = $event"
    />
    <saleInvoiceTaxAdjustment
      v-model:dialog="taxAdjustmentDialog"
      :data="taxAdjustmentData"
      @update:dialog="taxAdjustmentDialog = $event"
    />
    <saleCustomerBalanceSummary
      v-model:dialog="balanceSummaryDialog"
      :data="balanceSummaryData"
      @update:dialog="balanceSummaryDialog = $event"
    />
    <viewSaleInvoice
      v-if="invoiceDialog"
      :dialog="invoiceDialog"
      :invoice-id="selectedInvoiceId"
      @update:dialog="invoiceDialog = $event"
    />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, nextTick } from "vue";
import { toast } from "vue3-toastify";
import { shallowRef } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";
import poPaymentSetup from "@/components/module/sales/poPaymentSetup.vue";
import saleInvoiceTaxAdjustment from "@/components/module/sales/orderManagement/saleInvoiceTaxAdjustment.vue";
import saleCustomerBalanceSummary from "@/components/module/sales/orderManagement/saleCustomerBalanceSummary.vue";
import BaseCard from "@/components/utils/baseCard.vue";
import viewSaleInvoice from "@/components/module/sales/orderManagement/viewSaleInvoice.vue";

export default {
        components: {
          BaseCard,
          poPaymentSetup,
          saleInvoiceTaxAdjustment,
          saleCustomerBalanceSummary,
          viewSaleInvoice,
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            taxAdjustmentDialog: false,
            taxAdjustmentData: {},
            balanceSummaryDialog: false,
            balanceSummaryData: {},
            invoiceDialog: false,
            selectedInvoiceId: null,
            statusMap,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
                { title: "Invoice No", key: "code",align: "center" , sortable: false },
                { title: "Order No", key: "sale_invoice_delivery.invoice_master.code",align: "center" , sortable: false },
                { title: "Old Invoice No", key: "ref_no",align: "center" , sortable: false },
                { title: "Po/ Ref no", key: "po_no",align: "center" , sortable: false },
                { title: "Work Order", key: "work_order",align: "center" , sortable: false },
                { title: "Sale Invoice Date", key: "sale_invoice_date", align: "center" , sortable: false },
                { title: "Sale Order Date", key: "sale_invoice_delivery.invoice_master.sale_order_date", align: "center" , sortable: false },
                { title: "Shipping Date", key: "shipping_date",align: "center" , sortable: false },
                { title: "Customer", key: "customer",align: "center" , sortable: false },
                { title: "Sales Person", key: "sale_invoice_delivery.invoice_master.employee.name",align: "center" , sortable: false },
                { title: "Sub Total", key: "sub_total",align: "center" , sortable: false },
                { title: "Discount", key: "discount_amount", align: "center" , width: "60px", sortable: false },
                { title: "Vat", key: "vat_amount",align: "center" , width: "60px", sortable: false },
                { title: "Tax", key: "tax_amount",align: "center" , width: "60px", sortable: false },
                { title: "Total Amount",align: "center", key: "total", sortable: true },
                { title: "Paid", align: "center", key: "total_paid", sortable: true },
                 { title: "Tax Adjustment", align: "center", key: "tax_adjustment", sortable: true },
                { title: "Due", align: "center", key: "due_amount", sortable: true },
               
                { title: "Next Payment", key: "next_payment_date",align: "center" , sortable: false },
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Payment Status", align: "center", key: "payment_status", sortable: true },
                { title: "Actions", align: "center", key: "actions", width: "5%", sortable: false }
            ],
        }),
        watch: {
          invoiceDialog(val){
            this.$refs.searchButton.$el.click();
          }
        },
        created(){
            // if(this.$store.getters.getProjectList.length === 0) {this.$store.dispatch('getProjectList');}
        },
        computed:{
            getSchema() {
                return this.$store.getters.getSaleInvoiceList;
            },
            getProjectList() {
                // return this.$store.getters.getProjectList;
                return [];
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('From Date'),
                    // to_date: yup.date().required().label('To Date'),
                }),
            });

    const customer_id = useField("customer_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = 'blue-darken-3';
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSaleInvoiceList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      customer_id,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      // this.$store.commit('setEditingRfq', item);
      this.$router.push({
        name: "add-sale-invoice",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    canEdit(item){
      return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
    },
    poPayment(item) {
      this.data = { ...item };
      this.dialog = true;
    },
    openTaxAdjustment(item) {
      this.taxAdjustmentData = {
        sale_invoice_id: item.id,
        adjustment_date: "",
        amount: "",
      };
      this.taxAdjustmentDialog = true;
    },
    // poPayment(item) {
    //   this.$router.push({
    //     name: "add-sale-invoice",
    //     query: { order_id: item.id }
    //   })
    // },
    openBalanceSummary(item) {
      if (item.customer_map_id) {
        this.balanceSummaryData = {
          id: item.customer_map_id,
          customer_id: item.customer_id,
          opening_balance: item.total,
          opening_date: item.sale_invoice_date,
          sale_invoice_master_id: item.id,
          ref_no: item?.ref_no,
        };
        this.balanceSummaryDialog = true;
      }
    },
    viewInvoice(item) {
      this.selectedInvoiceId = item.id;
      this.invoiceDialog = true;
    },
    exportToPDF() {
      let serialNumber = 1;

      const columns = [
        "#SL",
        "Invoice No",
        "Order No",
        "Old Invoice No",
        "PO / Ref No",
        "Work Order",
        "Sale Invoice Date",
        "Sale Order Date",
        "Shipping Date",
        "Customer",
        "Sales Person",
        "Sub Total",
        "Discount",
        "VAT",
        "Tax",
        "Total Amount",
        "Paid",
        "Due",
        "Next Payment",
        "Approval Status",
        "Status",
        "Payment Status",
      ];

      const rows = this.getSchema.map((item) => {
        const customer =
            item.customer?.company_name ||
            item.customer?.company_owner_name ||
            "";

        const salesPerson =
            item.sale_invoice_delivery?.invoice_master?.employee?.name || "";

        const workOrder = item.work_order?.code || "";

        let approvalStatus = item.approval_status || "";

        if (
            item.approval_current_process &&
            item.approval_current_process.status === "Pending"
        ) {
          approvalStatus =
              `Waiting for ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Approved"
        ) {
          approvalStatus =
              `Approved By ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Cancelled"
        ) {
          approvalStatus =
              `Cancelled By ${item.approval_current_process.approval_step_name?.name || ""}`;
        }

        const status =
            statusMap[item.status]?.label ||
            (item.status == 1 ? "POST" : "DRAFT");

        let paymentStatus = "";

        if (Number(item.due_amount) === Number(item.total)) {
          paymentStatus = "Not Paid";
        } else if (
            Number(item.due_amount) < Number(item.total) &&
            Number(item.due_amount) > 0
        ) {
          paymentStatus = "Partial Paid";
        } else if (Number(item.due_amount) <= 0) {
          paymentStatus = "Paid";
        }

        return [
          serialNumber++,
          item.code || "",
          item.sale_order?.code || "",
          item.ref_no || "",
          item.po_no || "",
          workOrder,
          item.sale_invoice_date || "",
          item?.sale_invoice_delivery?.invoice_master?.sale_order_date || "",
          item.shipping_date || "",
          customer,
          salesPerson,
          item.sub_total ?? 0,
          item.discount_amount ?? 0,
          item.vat_amount ?? 0,
          item.tax_amount ?? 0,
          item.total ?? 0,
          item.total_paid ?? 0,
          item.due_amount ?? 0,
          item.next_payment_date || "",
          approvalStatus,
          status,
          paymentStatus,
        ];
      });

      this.$exportTableToPDF(
          columns,
          rows,
          "Sale Invoice List",
          "sale_invoice_record_" + this.$fileDate(),
          "landscape"
      );
    },

    exportToExcel() {
      const data = [
        [
          "#SL",
          "Invoice No",
          "Order No",
          "Old Invoice No",
          "PO / Ref No",
          "Work Order",
          "Sale Invoice Date",
          "Sale Order Date",
          "Shipping Date",
          "Customer",
          "Sales Person",
          "Sub Total",
          "Discount",
          "VAT",
          "Tax",
          "Total Amount",
          "Paid",
          "Due",
          "Next Payment",
          "Approval Status",
          "Status",
          "Payment Status",
        ],
      ];

      let serialNumber = 1;

      this.getSchema.forEach((item) => {
        const customer =
            item.customer?.company_name ||
            item.customer?.company_owner_name ||
            "";

        const salesPerson =
            item.sale_invoice_delivery?.invoice_master?.employee?.name || "";

        const workOrder = item.work_order?.code || "";

        let approvalStatus = item.approval_status || "";

        if (
            item.approval_current_process &&
            item.approval_current_process.status === "Pending"
        ) {
          approvalStatus =
              `Waiting for ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Approved"
        ) {
          approvalStatus =
              `Approved By ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Cancelled"
        ) {
          approvalStatus =
              `Cancelled By ${item.approval_current_process.approval_step_name?.name || ""}`;
        }

        const status =
            statusMap[item.status]?.label ||
            (item.status == 1 ? "POST" : "DRAFT");

        let paymentStatus = "";

        if (Number(item.due_amount) === Number(item.total)) {
          paymentStatus = "Not Paid";
        } else if (
            Number(item.due_amount) < Number(item.total) &&
            Number(item.due_amount) > 0
        ) {
          paymentStatus = "Partial Paid";
        } else if (Number(item.due_amount) <= 0) {
          paymentStatus = "Paid";
        }

        data.push([
          serialNumber++,
          item?.code || "",
          item?.sale_order?.code || "",
          item?.ref_no || "",
          item?.po_no || "",
          workOrder,
          item?.sale_invoice_date || "",
          item?.sale_invoice_delivery?.invoice_master?.sale_order_date || "",
          item?.shipping_date || "",
          customer,
          salesPerson,
          item?.sub_total ?? 0,
          item?.discount_amount ?? 0,
          item?.vat_amount ?? 0,
          item?.tax_amount ?? 0,
          item?.total ?? 0,
          item?.total_paid ?? 0,
          item?.due_amount ?? 0,
          item?.next_payment_date || "",
          approvalStatus,
          status,
          paymentStatus,
        ]);
      });

      this.$exportTableToExcel(
          data,
          "sale_invoice_record_" + this.$fileDate()
      );
    },

    exportToCSV() {
      const data = [
        [
          "#SL",
          "Invoice No",
          "Order No",
          "Old Invoice No",
          "PO / Ref No",
          "Work Order",
          "Sale Invoice Date",
          "Sale Order Date",
          "Shipping Date",
          "Customer",
          "Sales Person",
          "Sub Total",
          "Discount",
          "VAT",
          "Tax",
          "Total Amount",
          "Paid",
          "Due",
          "Next Payment",
          "Approval Status",
          "Status",
          "Payment Status",
        ],
      ];

      let serialNumber = 1;

      this.getSchema.forEach((item) => {
        const customer =
            item.customer?.company_name ||
            item.customer?.company_owner_name ||
            "";

        const salesPerson =
            item.sale_invoice_delivery?.invoice_master?.employee?.name || "";

        const workOrder = item.work_order?.code || "";

        let approvalStatus = item.approval_status || "";

        if (
            item.approval_current_process &&
            item.approval_current_process.status === "Pending"
        ) {
          approvalStatus =
              `Waiting for ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Approved"
        ) {
          approvalStatus =
              `Approved By ${item.approval_current_process.approval_step_name?.name || ""}`;
        } else if (
            item.approval_current_process &&
            item.approval_current_process.status === "Cancelled"
        ) {
          approvalStatus =
              `Cancelled By ${item.approval_current_process.approval_step_name?.name || ""}`;
        }

        const status =
            statusMap[item.status]?.label ||
            (item.status == 1 ? "POST" : "DRAFT");

        let paymentStatus = "";

        if (Number(item.due_amount) === Number(item.total)) {
          paymentStatus = "Not Paid";
        } else if (
            Number(item.due_amount) < Number(item.total) &&
            Number(item.due_amount) > 0
        ) {
          paymentStatus = "Partial Paid";
        } else if (Number(item.due_amount) <= 0) {
          paymentStatus = "Paid";
        }

        data.push([
          serialNumber++,
          item?.code || "",
          item?.sale_order?.code || "",
          item?.ref_no || "",
          item?.po_no || "",
          workOrder,
          item?.sale_invoice_date || "",
          item?.sale_invoice_delivery?.invoice_master?.sale_order_date || "",
          item?.shipping_date || "",
          customer,
          salesPerson,
          item?.sub_total ?? 0,
          item?.discount_amount ?? 0,
          item?.vat_amount ?? 0,
          item?.tax_amount ?? 0,
          item?.total ?? 0,
          item?.total_paid ?? 0,
          item?.due_amount ?? 0,
          item?.next_payment_date || "",
          approvalStatus,
          status,
          paymentStatus,
        ]);
      });

      this.$exportTableToCSV(
          data,
          "sale_invoice_record_" + this.$fileDate()
      );
    },
  },
  mounted() {
    const today = new Date();
    const oneMonthBack = new Date();
    oneMonthBack.setMonth(today.getMonth() - 1);
    this.from_date.value.value = oneMonthBack;
    this.to_date.value.value = today;
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });
  },
};
</script>
